import React from 'react'
import styles from './styles.css'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import Modal from 'components/Modal'
import Button from 'components/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const messages = defineMessages({
  // Default dialog message.
  dialogMessage: "Are you sure?",
  // Default "OK" button text
  dialogOk: "Continue",
  // Default "Cancel" button text
  dialogCancel: "Close"
})

function ConfirmDialog(props) {
  const {
    message,
    submitMessage,
    cancelMessage,
    onSubmit,
    onCancel,
    isOpened,
    title
  } = props

  return (
    <Modal
      title={title}
      show={isOpened}
      className={styles.confirmationDialog}
      modalClassName={styles.modal}
      bodyClassName={styles.body}
      footer={(
        <Container>
          <Row>
            <Col xs={{ order: 'first' }} sm={{ span: 6, order: 'last'}}>
              <Button
                type='go'
                onClick={onSubmit}
              >
                { !!submitMessage ? submitMessage : (<FormattedMessage {...messages.dialogOk} />)}
              </Button>
            </Col>
            <Col sm={6}>
              <Button
                type='cancel'
                onClick={onCancel}
              >
                { !!cancelMessage ? cancelMessage : (<FormattedMessage {...messages.dialogCancel} />)}
              </Button>
            </Col>
          </Row>
        </Container>
      )}
    >
      <div data-testid='messageText'>
        { !!message ? message : (<FormattedMessage {...messages.dialogMessage} />)}
      </div>
    </Modal>
  )
}

export default ConfirmDialog
